import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}
export function Input({
  className = '',
  error,
  ...props
}: InputProps) {
  return <input className={`input-field ${error ? 'input-error' : ''} ${className}`} {...props} data-id="element-74" />;
}